export default __webpack_public_path__ + "static/media/copy-icon.56eeb9b7.svg";